import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Button, message } from 'antd';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';
import { auth } from '../../services/api';

interface AuthModalProps {
  visible: boolean;
  onClose: () => void;
  defaultTab?: 'login' | 'register';
  onSuccess?: () => void;
}

const AuthModal: React.FC<AuthModalProps> = ({
  visible,
  onClose,
  defaultTab = 'login',
  onSuccess
}) => {
  const [activeTab, setActiveTab] = useState<'login' | 'register'>(defaultTab);
  const [forgotPasswordVisible, setForgotPasswordVisible] = useState(false);
  const [forgotPasswordForm] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setActiveTab(defaultTab);
  }, [defaultTab]);

  const handleSuccess = () => {
    onSuccess?.();
    onClose();
  };

  const handleForgotPassword = async (values: any) => {
    try {
      setLoading(true);
      await auth.forgotPassword(values.email);
      message.success('重置密码链接已发送到您的邮箱');
      setForgotPasswordVisible(false);
      forgotPasswordForm.resetFields();
    } catch (error: any) {
      message.error(error.response?.data?.detail || '发送失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Modal
        open={visible}
        onCancel={onClose}
        footer={null}
        destroyOnClose
        title={activeTab === 'login' ? '登录' : '注册'}
        width={400}
      >
        {activeTab === 'login' ? (
          <LoginForm
            onSuccess={handleSuccess}
            onSwitchToRegister={() => setActiveTab('register')}
            onForgotPassword={() => setForgotPasswordVisible(true)}
          />
        ) : (
          <RegisterForm
            onSuccess={handleSuccess}
            onSwitchToLogin={() => setActiveTab('login')}
          />
        )}
      </Modal>

      <Modal
        title="忘记密码"
        open={forgotPasswordVisible}
        onCancel={() => setForgotPasswordVisible(false)}
        footer={null}
        destroyOnClose
      >
        <Form
          form={forgotPasswordForm}
          layout="vertical"
          onFinish={handleForgotPassword}
          preserve={false}
        >
          <Form.Item
            name="email"
            label="邮箱"
            rules={[
              { required: true, message: '请输入邮箱' },
              { type: 'email', message: '请输入有效的邮箱地址' }
            ]}
          >
            <Input placeholder="请输入您注册时使用的邮箱" />
          </Form.Item>
          
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              发送重置链接
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default AuthModal; 